import React, { useEffect, useState } from "react";

export const AboutUs = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [language, setLanguage] = useState("10"); // Default to "10" (Srpski)

    useEffect(() => {
        setIsLoaded(true);
        
        const storedLanguage = localStorage.getItem("selectedLanguage");
        if (storedLanguage) {
            setLanguage(storedLanguage);
        }

        const handleStorageChange = () => {
            setLanguage(localStorage.getItem("selectedLanguage") || "10");
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    return (
        <div>
            <div className={`barbershop-zajednica-about-us-title ${isLoaded ? 'fade-in' : ''}`}>
                {language === "20" ? "About Us" : "O Nama"}
            </div>
        </div>
    );
};
